import $ from 'jquery';
import DropdownSelect from '../../components/dropdown-select';
import RevealWhenVisible from '../../components/reveal-when-visible';
import ProductColorSelect from '../../components/product-color-select';
import LazyImages from '../../components/lazy-images';
import RelatedProductsSlider from '../../components/related-products-slider';
import RelatedAccessoriesSlider from '../../components/related-accessories-slider';
import Utils from '../../utils';
import Popover from './popover';
export default class LazyLoadContent {
    static $element = $('.js__lazy-load-content');
    static init() {
        if (this.$element.length) {
            this.addRevealObserver();
        }
    }
    static addRevealObserver() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const $element = $(entry.target);
                if (entry.isIntersecting) {
                    this.ajaxRequest($element);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5,
        });
        this.$element.each((index, element) => {
            observer.observe(element);
        });
    }
    static ajaxRequest($element) {
        const url = $element.data('url');
        const method = $element.data('method') || 'GET';
        const data = $element.data('data') || {};
        const contentElementSelector = $element.data('content-element-selector');
        const $contentElement = contentElementSelector ? $(contentElementSelector) : $element;
        Utils.contentLoader($contentElement, true);
        $.ajax({
            url,
            method,
            data,
            cache: false,
        })
            .done(response => {
            $contentElement.html(response);
            DropdownSelect.init($contentElement, true);
            RevealWhenVisible.init($contentElement);
            ProductColorSelect.init();
            LazyImages.init();
            RelatedProductsSlider.init($contentElement);
            RelatedAccessoriesSlider.init($contentElement);
            Popover.init($contentElement);
        })
            .always(() => {
            Utils.contentLoader($contentElement, false);
        });
    }
}
